import {BrowserRouter as Router,Route,Routes} from "react-router-dom";
import { initAll, identify, Identify } from '@amplitude/unified';
import './App.css';

import Home from "./Components/Home";
import Product from "./Components/Product";
import AboutUs from "./Components/AboutUs";

import './Styles/global.css'
import './Styles/responsive.css'

function App() {
const AMPLITUDE_API_KEY = process.env.REACT_APP_AMPLITUDE_ANALYTICS_KEY;
initAll(AMPLITUDE_API_KEY,{serverZone: 'EU'});
identify(new Identify().set('userType', 'General User'));
  return (
    <>
    <Router>
      <Routes>
        <Route path="/" element={<Home />} ></Route>
        <Route path="/product" element={<Product/>} ></Route>
        <Route path="/about-us" element={<AboutUs/>}></Route>
      </Routes>
    </Router>
    </>
  );
}

export default App;
